export default "__VITE_ASSET__fce9a306__"